module.exports = {
  siteTitle: 'Patricia Collado', // <title>
  manifestName: 'Grayscale',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/da1.png',
  pathPrefix: `/gatsby-starter-grayscale/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Patricia Collado',
  subHeading:
    'Data analyst and data engineer, lets automate the world together!',

  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/Patcm10',
    },
    {
      icon: 'fa-linkedin-in',
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/patricia-colladom1/',
    },
    {
      icon: 'fab fa-medium-m',
      name: 'Linkedin',
      url: null,
    },
  ],
  email: null,
  address: 'From Mexico to the rest of the world!',
};
